export function computeDedupKey(event: {
  venueName: string;
  startDatetime: string;
  title: string;
  headliner?: string;
}): string {
  const venue = event.venueName.trim().toLowerCase();
  const date = event.startDatetime.slice(0, 10);
  const headliner = (event.headliner || event.title).trim().toLowerCase();
  return `${venue}|${date}|${headliner}`;
}
